module.exports = __webpack_public_path__ + "static/img/ARAD4SN_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD4SN_1.png
// module id = NCqk
// module chunks = 0